import React from 'react';

interface HeaderTypes {}

const Header: React.FC<HeaderTypes> = () => {
  return <header></header>;
};

export default Header;
